import { ReactComponent as FooterLogo } from '../logos/Hibbert Logo.svg';

export default function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-inner">
        <p className="footer-copyright">© The Hibbert Group, 2026, All Rights Reserved</p>
        <div className="footer-logo-wrap">
          <FooterLogo className="footer-logo-img" role="img" aria-label="Hibbert" focusable="false" />
        </div>
      </div>
    </footer>
  );
}
